// Supabase 환경변수 설정
// 실제 사용 시 .env 파일에 다음 변수들을 설정하세요:
// REACT_APP_SUPABASE_URL=your_supabase_url_here
// REACT_APP_SUPABASE_ANON_KEY=your_supabase_anon_key_here
// REACT_APP_SUPABASE_PROJECT_ID=your_project_id_here

export const SUPABASE_CONFIG = {
  url: process.env.REACT_APP_SUPABASE_URL || 'your_supabase_url_here',
  anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || 'your_supabase_anon_key_here',
  projectId: process.env.REACT_APP_SUPABASE_PROJECT_ID || 'your_project_id_here'
};

// 환경변수 검증
export const validateSupabaseConfig = () => {
  const missingVars = [];
  
  if (!SUPABASE_CONFIG.url || SUPABASE_CONFIG.url === 'your_supabase_url_here') {
    missingVars.push('REACT_APP_SUPABASE_URL');
  }
  
  if (!SUPABASE_CONFIG.anonKey || SUPABASE_CONFIG.anonKey === 'your_supabase_anon_key_here') {
    missingVars.push('REACT_APP_SUPABASE_ANON_KEY');
  }
  
  if (!SUPABASE_CONFIG.projectId || SUPABASE_CONFIG.projectId === 'your_project_id_here') {
    missingVars.push('REACT_APP_SUPABASE_PROJECT_ID');
  }
  
  if (missingVars.length > 0) {
    console.warn('다음 Supabase 환경변수들이 설정되지 않았습니다:', missingVars.join(', '));
    console.warn('.env 파일에 다음 변수들을 설정하세요:');
    missingVars.forEach(varName => {
      console.warn(`  ${varName}=your_value_here`);
    });
    return false;
  }
  
  return true;
};
